import React from 'react';
import { useSelector } from 'react-redux';
import { can } from '../../permissions';

export default function PermissionGate({ module, action, children }) {
  const user = useSelector(state => state.AppReducer.user);
  return can(user, module, action) ? children : null;
}
